import DOMPurify from 'dompurify';
import { useState } from "react";
import BordersStyles from './Borders.module.css';
import { LeftPage, RightPage } from './Footer';
import { BlogPosts } from './Blogposts.js';
import { QuoteList } from './Quotes.js';

/* For the individual layouts of the chapters and sections on each page. */

/*Layout for Table of Contents */
export function TableOfContentsLayout({ section, img, alt }) {
  return (
    <>
    <section className={BordersStyles["BoA-left-page"]}>
      <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-ToC-left"]}>
        
        <span className={BordersStyles["BoA-main-chapter-title"]} id={BordersStyles["BoA-CT-left"]}>
            <h1 className={BordersStyles["BoA-Table-of-Contents"]}>{section}</h1>
            <img id={BordersStyles["BoA-" + section + "-decor-l1"]} src={img} alt={alt}/>
            <img id={BordersStyles["BoA-" + section + "-decor-l2"]} src={img} alt={alt}/>
        </span>

        <span className={BordersStyles["BoA-chapter-page-info-1"]}>
          <strong className={BordersStyles["BoA-ToC-page-number"]}>Artwork......................#4</strong>
        </span>

        <span className={BordersStyles["BoA-chapter-page-info-2"]}>
          <strong className={BordersStyles["BoA-ToC-page-number"]}>Coding Projects.......#10</strong>
        </span>
        
        <span className={BordersStyles["BoA-page-number"]}>
          <strong className={BordersStyles["BoA-number"]}>{Number(LeftPage.GetPage)}</strong>
        </span>
      
      </div>
    </section>

    <section className={BordersStyles["BoA-right-page"]}>
      <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-ToC-right"]}>
      
        <span className={BordersStyles["BoA-main-chapter-title"]} id={BordersStyles["BoA-CT-right"]}>
          <h1 className={BordersStyles["BoA-Table-of-Contents"]}>{section}</h1>
          <img id={BordersStyles["BoA-" + section + "-decor-r1"]} src={img} alt={alt}/>
          <img id={BordersStyles["BoA-" + section + "-decor-r2"]} src={img} alt={alt}/>
        </span>
                
        <span className={BordersStyles["BoA-chapter-page-info-3"]}>
          <strong className={BordersStyles["BoA-ToC-page-number"]}>Writing......................#20</strong>
        </span>

        <span className={BordersStyles["BoA-chapter-page-info-4"]}>
          <strong className={BordersStyles["BoA-ToC-page-number"]}>About.......................#22</strong>
        </span>
        
        <span className={BordersStyles["BoA-page-number"]}>
          <strong className={BordersStyles["BoA-number"]}>{Number(RightPage.GetPage)}</strong>
        </span> 
      </div>
    </section>
    </>
  );
}

/*Layout for Artwork */
export function ArtworkLayout({ section, img1, img2, img3, img4, alt1, alt2, alt3, alt4, 
  title, description, cap1, cap2, link1, link2 }) { 
    // Note: add image thumbnails for code (thumb1, thumb2, thumb3) EDIT: NVM, just replacing with smaller files

    /*Image Zoom Inspired by this approach:
    https://medium.com/@thomasaugot/adding-zoom-functionality-to-an-image-viewer-in-react-next-js-4621be8eb770 
    Also taking similar approach with Header animation triggers.
    */

    // State variable for managing zoomed image, animation and caption
    const [zoomedImage, setZoomedImage] = useState(null);
    const [zoomedCap, setZoomedCap] = useState(null);
    const [anime, setAnime] = useState(null);

    // Function to open zoomed image
    const openZoomedImage = (url) => {
      setAnime(true);
      setZoomedImage(url);

      /* If Image SRC matches a certain image, change the caption to the one
      corresponding to the image. */
      switch(url) {
        case img3: 
          setZoomedCap(cap1);
          break;
        case img4:
          setZoomedCap(cap2);
          break;
        default:
          setZoomedCap(title + ": " + description);
      }
    };
    console.debug("Test value? " + anime);

    // Function to close zoomed image
    const closeZoomedImage = () => {
      console.debug("Image closing is clicked.");
      setAnime(false);
      setTimeout(() => {
        setZoomedImage(null);
      }, 275);
      //console.debug("Test value? " + anime);
      /*<figure className={BordersStyles["BoA-zoomed-media-border"]}> */
    };  

  return(   
      <>              
      {zoomedImage && (
        <div className={BordersStyles["BoA-zoomed-media-container"]} onClick={closeZoomedImage} value={anime}>
          <figure className={BordersStyles["BoA-zoomed-media-border"]}>
            <img id={BordersStyles["BoA-zoomed-image"]} src={zoomedImage} alt={alt2}/>
            <figcaption id={BordersStyles["BoA-zoomed-image-caption"]}>{zoomedCap}</figcaption>
          </figure>
        </div>
        )}  
      <section className={BordersStyles["BoA-left-page"]}>
        <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-Art-left"]}>  
        <span className={BordersStyles["BoA-main-chapter-title"]} id={BordersStyles["BoA-CT-left"]}>
          <h1 id={BordersStyles["BoA-" + section]}>{section}</h1>
          <img id={BordersStyles["BoA-" + section + "-decor-l1"]} src={img1} alt={alt1}/>
          <img id={BordersStyles["BoA-" + section + "-decor-l2"]} src={img1} alt={alt1}/>
        </span>

        <span className={BordersStyles["BoA-" + section + "-work-info"]}>
          <strong id={BordersStyles["BoA-" + section + "-piece-title"]} alt="Title">{title}</strong>
          <figure className={BordersStyles["BoA-" + section + "-image"]}>
            <img id={BordersStyles["BoA-" + section + "-piece"]} src={img2} alt={alt2} 
            onClick={() => openZoomedImage(img2)}/>
          </figure>
              {/* Insert artwork image as child below. */}
          <div className={BordersStyles["BoA-" + section + "-description"]}>
            <p id={BordersStyles["BoA-" + section + "-description-text"]}>{description}</p>
          </div>

        </span> 

        <span className={BordersStyles["BoA-page-number"]}>
          <strong className={BordersStyles["BoA-number"]}>{Number(LeftPage.GetPage)}</strong>
        </span>
       </div>
      </section>      

      <section className={BordersStyles["BoA-right-page"]}>
        <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-Art-right"]}>
          <figure className={BordersStyles["BoA-" + section + "-image-alts"]}>
            <img className={BordersStyles["BoA-" + section + "-piece-alts"]} src={img3} alt={alt3} 
            onClick={() => openZoomedImage(img3)}/>
            {/* Note: FIGCAPTION DOESN'T WORK. Unless getting text inside the border is what is intended. 
            (hint: it's not.)*/}
          </figure>
            <strong className={BordersStyles["BoA-caption-alts"]}>{cap1}</strong>
          <figure className={BordersStyles["BoA-" + section + "-image-alts"]}>
            <img className={BordersStyles["BoA-" + section + "-piece-alts"]} src={img4} alt={alt4} 
            onClick={() => openZoomedImage(img4)}/>
          </figure>
            <strong className={BordersStyles["BoA-caption-alts"]}>{cap2}</strong>

          <span className={BordersStyles["BoA-" + section + "-links"]}>
            <p id={BordersStyles["BoA-" + section + "-links-dl"]}>Image Download 
              {/*insert links after finding icon later
              <a href={link1} target="_blank" rel="noopener noreferrer"></a>*/}
              <a href={link1} target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-download" value={section + "-icon"} />
              </a>
            </p>
            <p id={BordersStyles["BoA-" + section + "-links-nl"]}>Image Link
              {/*insert links after finding icon later
              <a href={link2} target="_blank" rel="noopener noreferrer"></a>*/}
              <a href={link2} target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-deviantart" value={section + "-icon"}/>
              </a>
            </p>
          </span>

          <span className={BordersStyles["BoA-page-number"]}>
            <strong className={BordersStyles["BoA-number"]}>{Number(RightPage.GetPage)}</strong>
          </span> 
        </div>
      </section>
      
      </>
    );
}

/*Layout for Coding Projects */
export function CodingProjectsLayout({ section, img1, img2, img3, img4, img5, alt1, alt2, alt3, alt4, alt5, vid1, vid2, 
  title, description, cap1, cap2, cap3, web1, web2, web3, icon1, icon2, icon3, link1, link2, link3 }) {

    // State variables for managing zoomed images, videos, animation and captions
    const [zoomedImage, setZoomedImage] = useState(null);
    const [zoomedVideo, setZoomedVideo] = useState({webm: null, mp4: null});
    const [zoomedCap, setZoomedCap] = useState(null);
    const [anime, setAnime] = useState(null);

    // Function to open zoomed image
    const openZoomedImage = (url) => {
      setAnime(true);
      setZoomedImage(url);

      /* If Image SRC matches a certain image, change the caption to the one
      corresponding to the image. */
      switch(url) {
        case img3: 
          setZoomedCap(cap1);
          break;
        case img4:
          setZoomedCap(cap2);
          break;
        case img5:
          setZoomedCap(cap3);
          break;
        default:
          setZoomedCap(title + ": " + description);
      }
    };

     // Function to close zoomed image
     const closeZoomedImage = () => {
        console.debug("Image closing is clicked.");
        setAnime(false);
        setTimeout(() => {
          setZoomedImage(null);
        }, 275);
        //console.debug("Test value? " + anime);
     };  

    //Function for opening video (2026: alternative for GIF animations)
    const openZoomedVideo = (url1, url2) => {
      console.debug("Video opening commenced.");
      setAnime(true);
      setZoomedVideo({webm: url1, mp4: url2});
      setZoomedCap(cap1);
    }

    // Function to close video
    const closeZoomedVideo = () => {
      console.debug("Video closing is clicked.");
      setAnime(false);
      setTimeout(() => {
        setZoomedVideo({webm: null, mp4: null});
      }, 275);
      //console.debug("Test value? " + anime);
     };  

  
  return(
    <>            
    {zoomedImage && (
      <div className={BordersStyles["BoA-zoomed-media-container"]} onClick={closeZoomedImage} value={anime}>
        <figure className={BordersStyles["BoA-zoomed-media-border"]} onClick={closeZoomedImage} value={anime}>
          <img id={BordersStyles["BoA-zoomed-image"]} src={zoomedImage} alt={alt2}/>
          <figcaption id={BordersStyles["BoA-zoomed-image-caption"]}>{zoomedCap}</figcaption>
        </figure>
      </div>
    )}
    {(zoomedVideo.webm || zoomedVideo.mp4) && (
      <div className={BordersStyles["BoA-zoomed-media-container"]} onClick={closeZoomedImage} value={anime}>
        <figure className={BordersStyles["BoA-zoomed-media-border"]} onClick={closeZoomedVideo} value={anime}>
          <video id={BordersStyles["BoA-zoomed-video"]} autoPlay loop muted playsInline>
            <source src={zoomedVideo.webm} type="video/webm"/>
            <source src={zoomedVideo.mp4} type="video/mp4"/>
            Your browser does not support the video tag.
          </video>
          <figcaption id={BordersStyles["BoA-zoomed-video-caption"]}>{zoomedCap}</figcaption>
        </figure>
      </div>
    )}
    <section className={BordersStyles["BoA-left-page"]}>
      <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-Code-left"]}>  
      <span className={BordersStyles["BoA-main-chapter-title"]} id={BordersStyles["BoA-CT-left"]}>
          <h1 id={BordersStyles["BoA-" + section]}>{section}</h1>
          <img id={BordersStyles["BoA-" + section + "-decor-l1"]} src={img1} alt={alt1}/>
          <img id={BordersStyles["BoA-" + section + "-decor-l2"]} src={img1} alt={alt1}/>
      </span>

    {/*Why does this not work when using "BoA-" + section + "-info"? 
    Not adding yet because it's minor enough to not matter too much... for now. */}
      <span className={BordersStyles["BoA-coding-info"]}>
        <strong id={BordersStyles["BoA-coding-title"]} alt="Title">{title}{/*insert logo to right of title */}</strong>
        <figure className={BordersStyles["BoA-coding-image"]}>
          
          {/* If the content is an MP4 or WebM video, call video opener function. Otherwise call image opener.*/}
          <img id={BordersStyles["BoA-coding-piece"]} src={img2} alt={alt2} 
          onClick={img2.toString().includes("TitleScreen") ? () => openZoomedVideo(vid1, vid2) : () => openZoomedImage(img2)}/> 
            {/* Insert artwork image as child below. */}
        </figure>

        <div className={BordersStyles["BoA-coding-description"]}>
          <p id={BordersStyles["BoA-coding-description-text"]}>{description}</p>
        </div>
      </span> 

      <span className={BordersStyles["BoA-page-number"]}>
        <strong className={BordersStyles["BoA-number"]}>{Number(LeftPage.GetPage)}</strong>
      </span>      
      </div>
    </section>  

    <section className={BordersStyles["BoA-right-page"]}>
      <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-Code-right"]}>  
        <div className={BordersStyles["BoA-coding-image-alts"]}> 
            <figure className={BordersStyles["BoA-coding-image-border-2"]}>
              <img className={BordersStyles["BoA-coding-piece-alts"]} src={img3} alt={alt3}
              onClick={() => openZoomedImage(img3)}/>
            </figure>
              <p className={BordersStyles["BoA-coding-caps"]}>{cap1}</p>

            <figure className={BordersStyles["BoA-coding-image-border-2"]}>
              <img className={BordersStyles["BoA-coding-piece-alts"]} src={img4} alt={alt4} 
              style={{gridColumn:"2", gridRow: "2"}}
              onClick={() => openZoomedImage(img4)}/>
            </figure>
              <p className={BordersStyles["BoA-coding-caps"]} 
              style={{gridColumn:"1", gridRow: "2"}}>{cap2}</p>

            <figure className={BordersStyles["BoA-coding-image-border-2"]}>
              <img className={BordersStyles["BoA-coding-piece-alts"]} src={img5} alt={alt5}
              onClick={() => openZoomedImage(img5)}/>
            </figure>
              <p className={BordersStyles["BoA-coding-caps"]}>{cap3}</p>
        </div>
        
        <span className={BordersStyles["BoA-coding-links"]}>
          <p id={BordersStyles["BoA-coding-links-1"]}>{web1}</p>
            {/*insert links after finding icon later
            <a href={link1} target="_blank" rel="noopener noreferrer"></a>*/}
            <a href={link1} target="_blank" rel="noopener noreferrer">
              <i className={icon1} value={section + "-icon"} />
            </a>
          <p id={BordersStyles["BoA-coding-links-2"]}>{web2}</p>
            {/*insert links after finding icon later
            <a href={link2} target="_blank" rel="noopener noreferrer"></a>*/}
            <a href={link2} target="_blank" rel="noopener noreferrer">
              <i className={icon2} value={section + "-icon"} />
            </a>
          <p id={BordersStyles["BoA-coding-links-3"]}>{web3}</p>
            {/*insert links after finding icon later
            <a href={link3} target="_blank" rel="noopener noreferrer"></a>*/}
            <a href={link3} target="_blank" rel="noopener noreferrer">
              <i className={icon3} value={section + "-icon"} />
            </a>
        </span>

        <span className={BordersStyles["BoA-page-number"]}>
          <strong className={BordersStyles["BoA-number"]}>{Number(RightPage.GetPage)}</strong>
        </span>
      </div>
    </section>
    </>
  );
}

/*Layout for Writing */
export function WritingLayout({ section, img1, img2, alt1, alt2 }) {

/*
 {QuoteList.map((post, key) => (
  <div id={BordersStyles["BoA-quote-post-1"]} key={key}>
    <h2 className={BordersStyles["BoA-quote-title"]}>{post.quotetitle}</h2>
    <time className={BordersStyles["BoA-quote-date"]} dateTime={post.quotedate}>
                {"#" + post.quoteID + ": " + post.quotedate}</time>
    <p className={BordersStyles["BoA-quote-excerpt"]}>{"\"" + post.quote + "\""}</p>
  </div>
  ))}
 */

 // State variable for managing post and animation 
    const [postInfo, setPostInfo] = useState(null);
    const [anime, setAnime] = useState(null);
    const [postHTML, setPostHTML] = useState(null);

    // Function to open individual post
    const openPost = (title, date, image, alt, id, genre, link1, link2, post) => {
      setPostHTML(DOMPurify.sanitize(post, { ADD_ATTR: ['target']}));
      setAnime(true);
      setPostInfo({      
        posttitle: title,
        postdate: date,
        postimage: image,
        postimagedesc: alt,
        postID: id,
        postgenre: genre,
        postlink1: link1,
        postlink2: link2,
        post: postHTML /* Don't use postHTML, as the first result when clicking post 
        returns upon first click either a blank page, or the previous post value saved.*/
      });
    };
 
     // Function to close post
     const closePost = () => {
        console.debug("Post closing is clicked.");
        setAnime(false);
        setTimeout(() => {
          setPostInfo(null);
        }, 275);
     };  
  
  return(
  <>
   {postInfo && (
      <section className={BordersStyles["BoA-post-background"]} value={anime}>
        <span className={BordersStyles["BoA-post-scroll"]} value={anime}>
          <article className={BordersStyles["BoA-post-layout"]}>
            <figure className={BordersStyles["BoA-post-main-image-border"]}>
              <img id={BordersStyles["BoA-post-image"]} src={postInfo.postimage} alt={postInfo.postimagedesc}/>
            </figure>
            <span className={BordersStyles["BoA-post-info"]}>
              <strong id={BordersStyles["BoA-post-title"]}>{postInfo.posttitle}</strong>
              <strong id={BordersStyles["BoA-post-metadata"]}>
               #{postInfo.postID}: {postInfo.postdate} | {postInfo.postgenre} | 
                {postInfo.postlink1 && ( 
                  <a className={BordersStyles["BoA-post-ext-link"]} 
                      href={postInfo.postlink1} 
                      target="_blank" 
                      rel="noopener noreferrer">
                    <i className="fa-brands fa-deviantart" value={section + "-icon"} title="DeviantArt Link"> | </i>
                  </a>)} 
                {postInfo.postlink2 && (
                  <a className={BordersStyles["BoA-post-ext-link"]} 
                      href={postInfo.postlink2} 
                      target="_blank" 
                      rel="noopener noreferrer">     
                    <i className="fa-brands fa-medium" value={section + "-icon"} title="Medium Link"> | </i>
                  </a>
                )}
                <button className={BordersStyles["BoA-post-close-mini"]}>
                  <img id={BordersStyles["BoA-post-close-mini-logo"]} 
                  src={img1} 
                  alt="Close Icon" 
                  title="Close Post" 
                  onClick={closePost}/>
                </button>
              </strong>
              <pre id={BordersStyles["BoA-post-writing"]} dangerouslySetInnerHTML={{__html: postHTML}}></pre>
            </span>
            <figure className={BordersStyles["BoA-post-close"]}>
              <img id={BordersStyles["BoA-post-close-logo"]} src={img1} alt="Close Icon" onClick={closePost}/>
              <figcaption id={BordersStyles["BoA-post-close-text"]}>Close</figcaption>
            </figure>
          </article>
        </span>     
      </section>
    )} 
  <section className={BordersStyles["BoA-left-page"]}>
    <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-Write-left"]}>  

      <span className={BordersStyles["BoA-main-chapter-title"]} id={BordersStyles["BoA-CT-left"]}>
          <h1 id={BordersStyles["BoA-" + section]}>{section}</h1>
          <img id={BordersStyles["BoA-" + section + "-decor-l1"]} src={img1} alt={alt1}/>
          <img id={BordersStyles["BoA-" + section + "-decor-l2"]} src={img1} alt={alt1}/>
      </span>

      <span className={BordersStyles["BoA-writing-info"]}>
        <strong id={BordersStyles["BoA-writing-title"]}>Blog Entries</strong>
        <div className={BordersStyles["BoA-writing-posts"]}>
        {BlogPosts.toReversed().map((post, key) => (
          <span className={BordersStyles["BoA-writing-individual-post"]} key={key}>
            <figure className={BordersStyles["BoA-post-image-border"]} src={img2} alt={alt2}>
              <img id={BordersStyles["BoA-post-image-thumb"]} 
              src={post.postimage} 
              alt={post.postimagedesc}
              onClick={() => openPost(
                post.posttitle,
                post.postdate, 
                post.postimage, 
                post.postimagedesc, 
                post.postID, 
                post.postgenre,
                post.postlink1,
                post.postlink2,
                post.post)}
              />
            </figure>
            <section className={BordersStyles["BoA-writing-post-description"]}>
              <strong className={BordersStyles["BoA-post-title-desc"]}>{post.posttitlealt}</strong>
              <time className={BordersStyles["BoA-post-date-desc"]} dateTime={post.postdate}>
                {"#" + post.postID + ": " + post.postdate}</time>
              <p className={BordersStyles["BoA-post-snippets-genre"]}>{post.postgenre}</p>
            </section>
          </span>
          ))}
        </div>
      </span> 
      
      <span className={BordersStyles["BoA-page-number"]}>
        <strong className={BordersStyles["BoA-number"]}>{Number(LeftPage.GetPage)}</strong>
      </span>

    </div>
  </section>

  <section className={BordersStyles["BoA-right-page"]}>
    <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-Write-right"]}>  

      <span className={BordersStyles["BoA-main-chapter-title"]} id={BordersStyles["BoA-CT-right"]}>
          <strong id={BordersStyles["BoA-writing-quotes"]}>Quotes</strong>
      </span>

      <span className={BordersStyles["BoA-quote-posts"]}>
      {QuoteList.map((post, key) => (
        <div id={BordersStyles["BoA-quote-post-individual"]} key={key}>
          <h2 className={BordersStyles["BoA-quote-title"]}>{post.quotetitle}</h2>
          <time className={BordersStyles["BoA-quote-date"]} dateTime={post.quotedate}>
                {"#" + post.quoteID + ": " + post.quotedate}</time>
          <p className={BordersStyles["BoA-quote-excerpt"]}>{"\"" + post.quote + "\""}</p>
        </div>
      ))}
        {/* <div id={BordersStyles["BoA-quote-post-1"]}>
          <h2 className={BordersStyles["BoA-quote-title"]}>Title</h2>
          <time className={BordersStyles["BoA-quote-date"]}>
                {"#1: 11/30/21"}</time>
          <p className={BordersStyles["BoA-quote-excerpt"]}>"Quote"</p>
        </div>
        <div id={BordersStyles["BoA-quote-post-2"]}>
          <h2 className={BordersStyles["BoA-quote-title"]}>Title</h2>
          <p className={BordersStyles["BoA-quote-excerpt"]}>"Quote"</p>
        </div>
        <div id={BordersStyles["BoA-quote-post-3"]}>
          <h2 className={BordersStyles["BoA-quote-title"]}>Title</h2>
          <p className={BordersStyles["BoA-quote-excerpt"]}>"Quote"</p>
        </div> */}
      </span>

      <span className={BordersStyles["BoA-page-number"]}>
        <strong className={BordersStyles["BoA-number"]}>{Number(RightPage.GetPage)}</strong>
      </span>

    </div>
  </section>
  </>
  );
}

/* Layout for About (Add img4/alt4 later) */
export function AboutLayout({ section, img1, img2, img3, alt1, alt2, alt3, description1, description2, 
  link1, link2, link3, link4, mypic, mypicalt }) {
  return(
    <>
      <section className={BordersStyles["BoA-left-page"]}>
       <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-About-left"]}>  
          <span className={BordersStyles["BoA-main-chapter-title"]} id={BordersStyles["BoA-CT-left"]}>
            <h1 id={BordersStyles["BoA-" + section]}>{section}</h1>
            <img id={BordersStyles["BoA-" + section + "-decor-l1"]} src={img1} alt={alt1}/>
            <img id={BordersStyles["BoA-" + section + "-decor-l2"]} src={img1} alt={alt1}/>
          </span>

          <span className={BordersStyles["BoA-about-info"]}>
            <figure className={BordersStyles["BoA-about-image"]}>
              <img id={BordersStyles["BoA-website-logo-front"]} src={img2} alt={alt2}/>
              <img id={BordersStyles["BoA-website-logo-back"]} src={img3} alt={alt3}/>
            </figure>
           
            <div className={BordersStyles["BoA-about-description"]}>
              <p id={BordersStyles["BoA-website-description-text"]}>{description1}</p>
            </div>
            {/*insert link to website document later (if necessary)*/}
          </span>
          <span className={BordersStyles["BoA-page-number"]}>
            <strong className={BordersStyles["BoA-number"]}>{Number(LeftPage.GetPage)}</strong>
          </span>        
      </div>
    </section>

      <section className={BordersStyles["BoA-right-page"]}>
        <div className={BordersStyles["BoA-section-title-" + section]} id={BordersStyles["BoA-About-right"]}>  
          <span className={BordersStyles["BoA-author-info"]}>
            <figure className={BordersStyles["BoA-author-photo"]}>
              <img id={BordersStyles["BoA-vignette-portrait"]} src={mypic} alt={mypicalt}/>
            </figure>           
            <div className={BordersStyles["BoA-about-description"]}>
              <p id={BordersStyles["BoA-professional-description-text"]}>{description2}</p>
            </div>
          </span>

          <span className={BordersStyles["BoA-about-links"]}>
            <p id={BordersStyles["BoA-about-links-GH"]}>GitHub 
              <a href={link1} target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-github" value={section + "-icon"}/>
              </a>
            </p>
            <p id={BordersStyles["BoA-about-links-FG"]}>DeviantArt
              <a href={link2} target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-deviantart" value={section + "-icon"}/> 
              </a>
            </p>
            <p id={BordersStyles["BoA-about-links-LI"]}>LinkedIn
              <a href={link3} target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-linkedin" value={section + "-icon"}/>
              </a>
            </p>
            <p id={BordersStyles["BoA-about-links-ME"]}>Medium
              <a href={link4} target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-medium" value={section + "-icon"}/>
              </a>
            </p>
          </span>

          <span className={BordersStyles["BoA-page-number"]}>
            <strong className={BordersStyles["BoA-number"]}>{Number(RightPage.GetPage)}</strong>
          </span>
        </div>
      </section>
    </>
  );
}

/* Layout for Timeline */
export function TimelineLayout({ section, img1, alt1, event1, event2, event3, event4, event5 }) {
  const descripnums = 5;
  const Eventnums = [
     event1,
     event2, 
     event3,
     event4,
     event5
];
  return(
    <>
    <section className={BordersStyles["BoA-about-" + section]}>
        <span className={BordersStyles["BoA-main-chapter-title"]} id={BordersStyles["BoA-" + section + "-title"]}>
            <h1 id={BordersStyles["BoA-" + section]}>Time Line</h1>
            <img id={BordersStyles["BoA-" + section + "-decor-l1"]} src={img1} alt={alt1}/>
            <img id={BordersStyles["BoA-" + section + "-decor-l2"]} src={img1} alt={alt1}/>
          </span>
      <div className={BordersStyles["BoA-about-" + section + "-style"]}>
        {[...Array(descripnums)].map((e, i) => (
          <div className={BordersStyles["BoA-about-" + section + "-container"]} key={i}>
            <div className={BordersStyles["BoA-timeline-description"]} key={i}>
              <strong className={BordersStyles["BoA-timeline-description-text"]} key={e}>{Eventnums[i]}</strong>
            </div>
          </div>
        ))}
        
        {/*Add page number blocks for timeline later. 
        {Number(LeftPage.GetPage)}
        {Number(RightPage.GetPage)}*/}
          <span className={BordersStyles["BoA-page-number"]}>
            <strong className={BordersStyles["BoA-number"]}></strong>
          </span>   
          <span className={BordersStyles["BoA-page-number"]}> 
            <strong className={BordersStyles["BoA-number"]}></strong>
          </span>   
        </div>
    </section>
    </>
  );
}



  /* }  <h1 className={"BoA-element-test-" + section}>
          Hello <i>{section}</i>. Welcome!
        </h1> */

        /**
         * DO NOT DELETE!!!!
         * Description: Before 2020: browsed internet as kid */


         /* 

    // if (url.toString().includes("TitleScreen")) { // Only for GIF animation; will find alternative later.
      //   setZoomedImage(gif1);
      // } else {

  ---- Practice Code for List of Blog Posts ----  

  <strong className={BordersStyles["BoA-snippets-text"]}>Snippets...</strong>
  
    {BlogTest.map((post, key) => (
        <span className={BordersStyles["BoA-writing-individual-post"]} key={key}>
          <figure className={BordersStyles["BoA-post-image-border"]} src={img2} alt={alt2}>
            <img className={BordersStyles["BoA-post-image"]} src={post.postimage} alt={post.postimagedesc}/>
          </figure>

          <section className={BordersStyles["BoA-writing-post-description"]}>
            <strong className={BordersStyles["BoA-post-title"]}>{post.postID + ": " + post.posttitle}</strong>
            <time className={BordersStyles["BoA-post-date"]} dateTime="2018-07-07">{post.postdate}</time>
            <p className={BordersStyles["BoA-post-snippets-genre"]}>{post.postgenre}.</p>
          </section>
        </span>
   ))};
        <div className={BordersStyles["BoA-writing-posts"]}>

          <span className={BordersStyles["BoA-writing-individual-post"]}>
            <figure className={BordersStyles["BoA-post-image-border"]} src={img2} alt={alt2}>
              <img className={BordersStyles["BoA-post-image"]} src={img3} alt={alt3}/>
            </figure>
            
            <section className={BordersStyles["BoA-writing-post-description"]}>
              <strong className={BordersStyles["BoA-post-title"]}>Title</strong>
              <time className={BordersStyles["BoA-post-date"]} datetime="2018-07-07">July 7</time>
              <p className={BordersStyles["BoA-post-snippets-genre"]}>Snippets...</p>
            </section>
            </span>
          </div>

))};
  


---- Practice Code for Displaying Individual Posts ----  */